"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Bus;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Bus(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
    id: "prefix__Layer_6_copy",
    x: 0,
    y: 0,
    viewBox: "0 0 200 300",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("style", null, ".bus_blue{fill:#28639c} .bus_white{fill:#fff}"), /*#__PURE__*/React.createElement("path", {
    d: "M66 107.7c.1 5.5 1.5 10 3.2 9.9l1.3 73h-.7c-1.7 0-2.9 4.5-2.8 10.1.1 5.5 1.5 10 3.2 9.9h.5l.5 10 4.5 15.4c.2.9 1 1.6 2 1.6h44.7c.9 0 1.7-.7 2-1.6l4.5-15.4.5-10h.4c1.7 0 3.1-4.4 3.2-9.9.1-5.5-1.2-10.1-2.8-10.1h-.7l1.3-73c1.7 0 3.1-4.4 3.2-9.9.1-5.5-1.2-10-2.8-10l.7-25.7c0-2.9-1.9-5.5-4.7-6.4-6.2-1.9-13.2-3.2-27.3-3.2s-21.1 1.3-27.3 3.2c-2.8.9-4.7 3.4-4.7 6.4l.7 25.7c-1.4 0-2.7 4.5-2.6 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 106.6l2 129.1c0 .5.5 1 1 1h44c.5 0 1-.4 1-1l2-129.1s4.9-27.1 4.9-32.7-15.9-7.6-29.9-7.6-29.9 1.9-29.9 7.5 4.9 32.8 4.9 32.8zm-.3-29.3c4.5-.6 14.4-1.6 25.4-1.6 10.9 0 20.8 1.1 25.4 1.6 1.4.2 2.4 1.5 2.1 3l-5.1 25.4c-.2 1.2-1.3 2-2.4 2H80.2c-1.2 0-2.2-.8-2.4-2l-5.1-25.4c-.5-1.5.5-2.9 2-3z",
    className: "bus_blue"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123,
    cy: 73.1,
    rx: 2,
    ry: 4,
    transform: "rotate(-72.998 122.973 73.123)",
    className: "bus_white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 77,
    cy: 73.1,
    rx: 4,
    ry: 2,
    transform: "rotate(-17.001 77 73.094)",
    className: "bus_white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5 80.1l4.1 20.3c.1.7.8 1.2 1.5 1.2H99v-25c-10.3.1-19.5 1-24.2 1.6-.4.1-.8.3-1.1.6-.2.4-.3.9-.2 1.3zm27.5 21.5h19.9c.7 0 1.4-.5 1.5-1.2l4.1-20.3c.1-.4 0-.9-.3-1.2-.3-.4-.6-.6-1.1-.6-4.6-.6-13.9-1.6-24.2-1.6v24.9h.1z",
    className: "bus_white"
  }));
}
//# sourceMappingURL=bus.js.map